export interface TagWebEntity {
    id: string;
    name: string;
    isProduct: boolean
  }